import { Component, OnInit, EventEmitter, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { stateOptionsSample, serviceConstants } from 'src/app/constants/service.constants';
import * as $ from 'jquery';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { CommonService } from 'src/app/services/common.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { UserService } from "src/app/services/user.service";
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateObject, ScreenResponseModel, Document_Upload_File, SCREEN_CONTROL } from 'src/app/models/common';
import { FileService } from '../../../../services/file.service';
import { GrantsDatashareService } from '../../../../services/grants/grants-datashare.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-grants-spon-view-model',
  templateUrl: './grants-spon-view-model.component.html',
  styleUrl: './grants-spon-view-model.component.scss'
})
export class GrantsSponViewModelComponent implements OnInit {
  @Input() public Content: any;
  appid: string = "";
  formFields;
  stateOptions = stateOptionsSample;
  grantcurrencycode: any = "";
  granttype: number;
  budgetForm: UntypedFormGroup;
  permission: string;
  content: any;
  heading: string;
  ISFromAllocate: string;
  action: Subject<any> = new Subject();
  budgetTypeOptions = [];
  budgetSubTypeOptions = [];
  StatusStr: any;
  IsAllocatedDateModified: boolean = false;
  ALLOCATE_DATE: DateObject;
  CurrentDate: Date;
  allocationamount: any;
  expenditureamount: number;
  balanceamount: number;
  IsAllocate: string;
  IsClosed: string;

  uploadedFiles: Document_Upload_File[] = [];
  staticformFields: any;
  expStaticFields: any;
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  userType: string;
  minDate: Date;
  ApplicationID: any;
  SCREEN_MODEL: any = null;
  ScreenName: string = "";
  staticformFieldsLstest: any;
  GeneralInformationFields: any;
  Application_Type_ID: string = "";
  Currency_ID: string = "";
  Currenct_Currency_Symbol: string = "";
  Target_Currency_Symbol: string = "";
  CONVERSION_RATE: number = 0;
  RequestedAmount_Target_Convert: number = 0;
  AllocatedAmount_Target_Convert: number = 0;
  TotalAmount_Target_Convert: number = 0;
  consumedAmount_Target_Convert: number = 0;
  orgCurrency: string;
  currency: string;
  constructor(
    private summaryService: GrantsSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private userService: UserService,
    private commonService: CommonService,
    public fileService: FileService,
    public grantsDatashare: GrantsDatashareService,
    public datepipe: DatePipe,
  ) {
    this.getStaticFiledsData('SCR-036');
  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.appid)
      .subscribe(summary => {
        if (screenCode == 'SCR-036') {
          this.staticformFields = summary["Data"];
          if (this.staticformFields.SPON_ALLOCATION_DATE.IS_PASTDATES_ALLOWED) {
            this.minDate = new Date(); this.minDate.setHours(0, 0, 0, 0);
          }
          else {
            this.minDate = null;
          }
        }
        else {
          this.expStaticFields = summary["Data"];
          if (this.granttype == 2)
            this.expStaticFields.RECONCILIATION_UPLOAD.IS_MANDATORY = false;
        }
      });
  }

  ngOnInit() {
    this.grantsDatashare.GrantApplicationID.subscribe(x => {
      this.appid = x;
    });
    if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
      this.grantsDatashare.Application_Type_ID.subscribe(x => {
        this.Application_Type_ID = x;
      });
    }
    if (this.Currency_ID == null || this.Currency_ID == undefined || this.Currency_ID == "") {
      this.grantsDatashare.Currency_ID.subscribe(x => {
        this.Currency_ID = x;
      });
    }
    this.GetParentScreenFieldsConfigControls('GSP01');

    this.userType = this.userService.getUserType();
    const grantapp = this.commonService.getGrantsApp();// "8b3a39fb-99ee-44ce-8c03-c5417eb040d2";
    //this.appid = grantapp.ID;
    this.IsAllocate = this.Content.IsAllocate;
    this.ISFromAllocate = this.Content.ISFromAllocate;
    this.IsClosed = this.Content.IsClosed;
    this.granttype = 2;
    this.GetScreenConfigControls('SCR-036');
    this.getStaticFiledsData('SCR-036');
    this.getStaticFiledsData('SCR-030');

    this.getOnIntMethods();

    this.disable();
    this.budgetForm.controls['REQUESTED_AMOUNT']?.valueChanges.subscribe(value => {
      if (this.userType == "E") {
        const amount = Number(value);
        const qty = Number(this.CONVERSION_RATE);
        this.RequestedAmount_Target_Convert = Number((amount / qty).toFixed(2));
      }
    });
    this.budgetForm.controls['TOTAL_FEE']?.valueChanges.subscribe(value => {
      if (this.userType == "E") {
        const amount = Number(value);
        const qty = Number(this.CONVERSION_RATE);
        this.TotalAmount_Target_Convert = Number((amount / qty).toFixed(2));
      }
    });

    this.budgetForm.controls['ALLOCATION_AMOUNT']?.valueChanges.subscribe(value => {
      if (this.userType == "I") {
        const amount = Number(value);
        const qty = Number(this.CONVERSION_RATE);
        this.AllocatedAmount_Target_Convert = Number((amount * qty).toFixed(2));
      }
    });
    this.budgetForm.controls['EXPENDITURE_AMOUNT']?.valueChanges.subscribe(value => {
      if (this.userType == "E") {
        const amount = Number(value ?? 0);
        const qty = Number(this.CONVERSION_RATE);
        this.consumedAmount_Target_Convert = Number((amount / qty).toFixed(2));
      }
    });
  }

  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, this.ApplicationID, (ScreenData) => {
      this.SCREEN_MODEL = ScreenData;
      this.ScreenName = this.SCREEN_MODEL?.NAME;
      this.staticformFieldsLstest = ScreenData["SCREEN_CONTROL"];
    });
  }
  SaveCME_GM_APP() {
    let uploadData = new FormData();
    uploadData.append("ScreenControlsData", JSON.stringify(this.GeneralInformationFields));
    uploadData.append("APPLICATION_TYPE_ID", this.Application_Type_ID);
    uploadData.append("SUBMIT_STATUS", "0");
    uploadData.append("Currency_ID", this.Currency_ID);
    return this.summaryService.SaveCMEGeneralInfo("api/GMAPPSponsorship/Insert", uploadData);
  }
  GetParentScreenFieldsConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, this.ApplicationID, (ScreenData) => {
      this.GeneralInformationFields = ScreenData["SCREEN_CONTROL"];
    });
  }
  saveTempFiles(selectedFiles: any) {
    const formData = new FormData();
    formData.append(`files`, selectedFiles);
    return this.fileService.uploadMultiFiles(formData, "");
  }
  resetInput(event: Event) {
    (event.target as HTMLInputElement).value = '';
  }
  uploadchange(event, ques: any): void {
    //let Flag = true;
    let Isexe = false;
    let Is5oMB = false;
    let IscrdDownload = false;

    if (this.uploadedFiles == undefined || this.uploadedFiles == null)
      this.uploadedFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      let file = event.target.files[i].name;
      let ext = file.match(/\.([^\.]+)$/)[1];
      let filesize = event.target.files[i].size;

      if (file != null && (ext == 'exe')) {
        Isexe = true;
      }
      else if (file != null && (ext == 'crdownload')) {
        IscrdDownload = true;
      }
      else if (file != null && ((filesize > 52428800))) {
        Is5oMB = true;
      }
      else {
        this.saveTempFiles(event.target.files[i]).subscribe((result: any) => {
          let uploadFile = new Document_Upload_File();
          uploadFile.ID = result.Data[0].FileID;
          uploadFile.DOCUMENT_NAME = event.target.files[i].name;
          uploadFile.File = null;
          uploadFile.Status = "Add";
          uploadFile.UploadedDate = this.datepipe.transform(new Date().toUTCString(), 'dd-MMM-YYYY');
          let hasValue = this.uploadedFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
          if (hasValue.length > 0) {
            this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
          }
          else if (ques.IS_MULTISELECT) {
            this.uploadedFiles.push(uploadFile);
          } else {
            this.uploadedFiles.forEach((item) => {
              item.Status = "Delete";
            })
            this.uploadedFiles.push(uploadFile);
          }
        });

      }
    }
    if (Is5oMB && Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 50MB");
    }

    else if (Is5oMB) {
      this.commonService.ValidationBanner("Accepts maximum file size 50MB");
    }

    else if (Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
    }
    else if (IscrdDownload) {
      this.commonService.ValidationBanner("The system does not support .crdownload files. Please choose a different file format to save the details.")
    }
    else {

    }
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }
  OpenFile(item: Document_Upload_File): void {

    if (item.Status == "Edit") {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    }
  }

  isAllowedExtensionFile(Filename) {
    return this.commonService.isAllowedExtension(Filename);
  }


  DeleteUpload(file): void {

    let code = file.ID;
    if (file.Status == "Add") {
      this.uploadedFiles = this.uploadedFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x) => {
        if (x["Status"] == 2 && x["Data"] == false) {
          this.commonService.ValidationBanner(x["Message"]);
        }
        else {
          file.Status = "Delete";
          let index = this.uploadedFiles.findIndex(x => x.ID == file.ID);
          this.uploadedFiles.splice(index, 1);
        }
      });
    }
  }
  getOnIntMethods() {
    this.heading = this.Content.heading;

    this.budgetForm = new UntypedFormGroup({
      ID: new UntypedFormControl(null),
      APPLICATION_ID: new UntypedFormControl(null),
      BUGET_TYPE_ID: new UntypedFormControl("", [Validators.required]),
      BUDGET_SUB_TYPE_ID: new UntypedFormControl("", [Validators.required]),
      NOTES: new UntypedFormControl("", [Validators.required]),
      REQUESTED_AMOUNT: new UntypedFormControl("", [Validators.required]),
      TOTAL_FEE: new UntypedFormControl("", [Validators.required]),
      ALLOCATION_AMOUNT: new UntypedFormControl(null, [Validators.required]),
      ALLOCATION_DATE: new UntypedFormControl(null, [Validators.required]),
      ALLOCATION_NOTES: new UntypedFormControl(""),
      EXPENDITURE_AMOUNT: new UntypedFormControl(null, [Validators.required]),
      BALANCE_AMOUNT: new UntypedFormControl(""),
      STATUS: new UntypedFormControl(),
    });

    this.getFundCategoryList();

    if (this.heading == "View" || this.heading == "Edit") {
      this.GetEditData();
    }
    else {
      this.StatusStr = "Draft";
    }

    this.permission = this.commonService.getPagePermission("SCR036").toLowerCase();
    if (this.permission === 'view') {
      setTimeout(() => {
        this.budgetForm.disable({ emitEvent: false });
      }, 100);
    }

  }


  GetEditData(): void {
    this.summaryService.getSponBudget(this.Content.content.id, this.appid).subscribe(summary => {
      if (summary) {
        this.budgetForm.patchValue({
          ID: summary["ID"],
          APPLICATION_ID: summary["APPLICATION_ID"],
          BUGET_TYPE_ID: summary["BUGET_TYPE_ID"],
          BUDGET_SUB_TYPE_ID: summary["BUDGET_SUB_TYPE_ID"],
          TOTAL_FEE: summary["TOTAL_FEE"],
          REQUESTED_AMOUNT: summary["REQUESTED_AMOUNT"],
          NOTES: summary["NOTES"],
          ALLOCATION_AMOUNT: summary["ALLOCATION_AMOUNT"],
          ALLOCATION_DATE: summary["ALLOCATION_DATE"],
          ALLOCATION_NOTES: summary["ALLOCATION_NOTES"],
          EXPENDITURE_AMOUNT: summary["EXPENDITURE_AMOUNT"],
          STATUS: summary["STATUS"]

        });
        if (summary["STATUS"] == 11 || summary["STATUS"] == 12) {
          this.IsAllocate = "Y";
          if (this.heading == "Edit") {
            this.budgetForm.disable();
            this.budgetForm.controls["EXPENDITURE_AMOUNT"].enable();
          }
        }
        this.uploadedFiles = summary.uploadFiles;

        this.expenditureamount = summary["EXPENDITURE_AMOUNT"];
        this.allocationamount = summary["ALLOCATION_AMOUNT"];
        this.uploadedFiles = summary["uploadFiles"];
        if (summary["ALLOCATION_DATE"])
          this.budgetForm.controls["ALLOCATION_DATE"].setValue(new Date(summary["ALLOCATION_DATE"]));
        this.getFundSubCategoryList(summary["BUGET_TYPE_ID"]);

        this.StatusStr = summary["StatuStr"];
        this.budgetForm.controls["BALANCE_AMOUNT"].setValue(this.balanceamount == 0 ? null : this.balanceamount);
        this.budgetForm.controls["EXPENDITURE_AMOUNT"].setValue(this.expenditureamount == 0 ? null : this.expenditureamount);
        if (this.extendedForm) {
          this.extendedForm.rowid = summary.ID;
          this.extendedForm?.getResponse();
        }

        if (this.heading === 'View') {
          setTimeout(() => {
            this.budgetForm.disable({ emitEvent: false });
          }, 500);
        }
        setTimeout(() => {
          if (this.IsAllocate == "Y" || this.userType == "I") {
            this.budgetForm.controls["BUGET_TYPE_ID"].disable();
            this.budgetForm.controls["BUDGET_SUB_TYPE_ID"].disable();
            this.budgetForm.controls["TOTAL_FEE"].disable();
            this.budgetForm.controls["REQUESTED_AMOUNT"].disable();
            this.budgetForm.controls["NOTES"].disable();
          }
        }, 500);

debugger;
        this.CONVERSION_RATE = summary["CONVERSION_RATE"];
        if (this.userType == "E") {
          if (summary["STATUS"] >= 2) {
            this.RequestedAmount_Target_Convert = parseFloat((parseFloat(summary['REQUESTED_AMOUNT']) / summary["CONVERSION_RATE"]).toFixed(2));
            if (summary['ALLOCATION_AMOUNT']) {
              this.AllocatedAmount_Target_Convert = parseFloat((parseFloat(summary['ALLOCATION_AMOUNT']) / summary["CONVERSION_RATE"]).toFixed(2));
            }
            if (this.budgetForm.controls['TOTAL_FEE'].value) {
              this.TotalAmount_Target_Convert = parseFloat((parseFloat(this.budgetForm.controls['TOTAL_FEE'].value) / summary["CONVERSION_RATE"]).toFixed(2));
            }
            if (summary['EXPENDITURE_AMOUNT']) {
              this.consumedAmount_Target_Convert = parseFloat((parseFloat(summary['EXPENDITURE_AMOUNT']) / summary["CONVERSION_RATE"]).toFixed(2));
            }
            else {
              this.consumedAmount_Target_Convert = 0;
            }
          }
        }
        else {
          this.RequestedAmount_Target_Convert = parseFloat((parseFloat(summary['REQUESTED_AMOUNT']) * summary["CONVERSION_RATE"]).toFixed(2));
          if (summary['ALLOCATION_AMOUNT']) {
            this.AllocatedAmount_Target_Convert = parseFloat((parseFloat(summary['ALLOCATION_AMOUNT']) * summary["CONVERSION_RATE"]).toFixed(2));
          }
          if (this.budgetForm.controls['TOTAL_FEE'].value) {
            this.TotalAmount_Target_Convert = parseFloat((parseFloat(this.budgetForm.controls['TOTAL_FEE'].value) * summary["CONVERSION_RATE"]).toFixed(2));
          }
          if (summary['EXPENDITURE_AMOUNT']) {
            this.consumedAmount_Target_Convert = parseFloat((parseFloat(summary['EXPENDITURE_AMOUNT']) * summary["CONVERSION_RATE"]).toFixed(2));
          }
        }
      }


    });

  }

  getFundCategoryList() {
    let model = new ScreenResponseModel();
    if (this.appid == "" || this.appid == null || this.appid == undefined) {
      model.AppId = "-1";
    }
    else {
      model.AppId = this.appid;
      this.Currency_ID = "-1";
    }
    this.summaryService.getSponBudgetTypeList(model.AppId, this.Content.content.id, this.Currency_ID).subscribe((result) => {
      if (result != null) {
      this.budgetTypeOptions = [{ label: "Select", value: null, checked: true }].concat(result["MasterData1"]);
        if (result["AppCurrencyDropdown"] != null) {

           this.currency = result["AppCurrencyDropdown"].appCurrency_Symbol;
           this.orgCurrency = result["AppCurrencyDropdown"].orgCurrency_Symbol;

          if (this.userType == "E") {
            this.Currenct_Currency_Symbol = result["AppCurrencyDropdown"].appCurrency_Symbol;
            this.Target_Currency_Symbol = result["AppCurrencyDropdown"].orgCurrency_Symbol;
          }
          else {
            this.Currenct_Currency_Symbol = result["AppCurrencyDropdown"].orgCurrency_Symbol;
            this.Target_Currency_Symbol = result["AppCurrencyDropdown"].appCurrency_Symbol;
          }
        }
      }
    });
  }

  getFundSubCategoryList(typeid: any) {
    let model = new ScreenResponseModel();
    model.Id = typeid.value == undefined ? typeid : typeid.value;
    model.AppId = this.appid;
    if (this.appid == "" || this.appid == null || this.appid == undefined) {
      model.AppId = "-1";
    }
    else {
      model.AppId = this.appid;
    }
    model.RowId = this.Content.content.id;

    this.summaryService.getSponBudgetSubTypeList(model).subscribe((result) => {
      if (result != null) {
        this.budgetSubTypeOptions = result;
        this.budgetSubTypeOptions = [{ label: "Select", value: null, checked: true }].concat(this.budgetSubTypeOptions);
        this.disable();
      }
    });
  }

  disable() {
    if (this.budgetForm.controls['BUGET_TYPE_ID'].value == null || this.budgetForm.controls['BUGET_TYPE_ID'].value == "" || this.budgetForm.controls['BUGET_TYPE_ID'].value == undefined) {
      this.budgetForm.controls['BUDGET_SUB_TYPE_ID'].disable();
    } else {
      this.budgetForm.controls['BUDGET_SUB_TYPE_ID'].enable();
    }
  }

  getSelectedValue(value: any): void {
    this.getFundSubCategoryList(value);
    this.budgetForm.controls["BUDGET_SUB_TYPE_ID"].setValue("");
  }

  onAllocateDate(event) {
    this.IsAllocatedDateModified = true;
    this.ALLOCATE_DATE = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.IsAllocatedDateModified,
    }
  }

  GetAllocateDate(): DateObject {
    const formModel = this.budgetForm.getRawValue();
    const date = new Date(formModel.ALLOCATION_DATE);
    if (this.ComparingDates(this.CurrentDate, date) || this.ALLOCATE_DATE == null || this.ALLOCATE_DATE == undefined) {
      this.ALLOCATE_DATE = {
        Day: date.getDate(),
        Month: (date.getMonth() + 1),
        Year: date.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false
      }
    }
    return this.ALLOCATE_DATE;
  }
  ComparingDates(oldDate: any, newDate: any) {
    if (oldDate != undefined && oldDate != null && oldDate != '') {
      let oDt = oldDate.getDate().toString() + oldDate.getMonth().toString() + oldDate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt)
        return true;
      else
        return false;
    }
    else
      return false;
  }

  SaveBudget() {
    if (this.validateControls()) {
      const formData = this.budgetForm.getRawValue();
      formData.NOTES = formData.NOTES == null ? null : formData.NOTES == undefined ? undefined : formData.NOTES.trim();
      formData["TOTAL_FEE"] = parseInt(formData["TOTAL_FEE"]);
      formData["REQUESTED_AMOUNT"] = parseInt(formData["REQUESTED_AMOUNT"]);
      formData["uploadFiles"] = this.uploadedFiles;
      formData["GRANTTYPE"] = this.granttype;
      formData["CURRENCY_SYMBOL"] = this.grantcurrencycode;

      if (this.heading == "Add") {
        if (!this.appid) {
          this.SaveCME_GM_APP().subscribe((result) => {

            if (result != null && result.Status == 0) {
              this.ApplicationID = result["TransactionID"];
              this.appid = result["TransactionID"];
              this.commonService.appId = this.appid;
              formData["APPLICATION_ID"] = this.appid;
              this.grantsDatashare.setGrantApplicationID(this.ApplicationID);
              this.summaryService.Insert('api/sponbudget/insert', formData).subscribe(summary => {
                if (summary.Status == 0) {
                  this.extendedForm.saveControls(summary.TransactionID, this.appid, summary.TransactionCode).subscribe(result => {
                    if (result.Status === 0) {
                      this.commonService.SuccessBanner(this.ScreenName + " saved successfully");
                      this.commonService.refreshApplicationPage(this.appid, "grants");
                      this.modalRef.close();
                    }
                    else {
                      this.commonService.ValidationBanner(result.Message);
                    }
                  });
                }
              });
            }
          })
        }
        else {
          formData["APPLICATION_ID"] = this.appid;
          this.summaryService.Insert('api/sponbudget/insert', formData).subscribe(summary => {
            if (summary.Status == 0) {
              this.extendedForm.saveControls(summary.TransactionID, this.appid, summary.TransactionCode).subscribe(result => {
                if (result.Status === 0) {
                  this.commonService.SuccessBanner(this.ScreenName + " saved successfully");
                  this.modalRef.close();
                }
                else {
                  this.commonService.ValidationBanner(result.Message);
                }
              });
            }
          });
        }
      }
      else {
        formData["APPLICATION_ID"] = this.appid;
        if (this.ISFromAllocate == "Y") {
          formData["STATUS"] = 11;
        }
        formData["ALLOCATION_AMOUNT"] = parseInt(formData["ALLOCATION_AMOUNT"]);
        formData["EXPENDITURE_AMOUNT"] = parseInt(formData["EXPENDITURE_AMOUNT"]);
        formData["SCREEN_NAME"] = this.Content.content.screen;

        if (formData["ALLOCATION_DATE"] != null && formData["ALLOCATION_DATE"] != "") {
          formData["ALLOCATION_DATE"] = new Date(formData["ALLOCATION_DATE"]);
        }
        formData["AllocationDateO"] = this.GetAllocateDate();
        formData["APPLICATION_ID"] = this.appid;
        this.summaryService.Update('api/sponbudget/update', formData).subscribe(result => {
          if (result.Status === 0 || result.ErrorCode == "NOCHANGES") {
            this.extendedForm.saveControls(result.TransactionID, this.appid, result.TransactionCode).subscribe(summary1 => {
              if (summary1.ErrorCode === "NOCONTROLS") {
                if (result.Status === 0) {
                  this.commonService.SuccessBanner(this.ScreenName + " updated successfully");
                  this.modalRef.close();
                }
                else {
                  this.commonService.ValidationBanner(result.Message);
                }
              } else {
                if (result.ErrorCode === "NOCHANGES" && summary1.ErrorCode === "NOCHANGES") {
                  this.commonService.ValidationBanner(result.Message);
                }
                else {
                  this.commonService.SuccessBanner(result.Message);
                  this.modalRef.close();
                }
              }

            });
          }
          else {
            this.commonService.ValidationBanner(result.Message);
          }

        });
      }
    }
  }

  validateControls() {
    let formDate = this.budgetForm.getRawValue();

    let isValid = true;
    let message = "";

    if (this.staticformFields.SPON_BUDGET_TYPE_ID.RECORD_STATE == 1 && this.staticformFields.SPON_BUDGET_TYPE_ID.IS_MANDATORY) {
      if (formDate.BUGET_TYPE_ID === null || formDate.BUGET_TYPE_ID === "" || formDate.BUGET_TYPE_ID === undefined) {
        $("#BUGET_TYPE_ID").addClass("ng-touched ng-invalid validate-error");
        $("#BUGET_TYPE_ID").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields.SPON_BUDGET_TYPE_ID.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#BUGET_TYPE_ID").addClass("ng-untouched ng-valid");
        $("#BUGET_TYPE_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields.SPON_BUDGET_SUB_TYPE_ID.RECORD_STATE == 1 && this.staticformFields.SPON_BUDGET_SUB_TYPE_ID.IS_MANDATORY) {
      if (formDate.BUDGET_SUB_TYPE_ID === null || formDate.BUDGET_SUB_TYPE_ID === "" || formDate.BUDGET_SUB_TYPE_ID === undefined) {
        $("#BUDGET_SUB_TYPE_ID").addClass("ng-touched ng-invalid validate-error");
        $("#BUDGET_SUB_TYPE_ID").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields.SPON_BUDGET_SUB_TYPE_ID.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#BUDGET_SUB_TYPE_ID").addClass("ng-untouched ng-valid");
        $("#BUDGET_SUB_TYPE_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields.SPON_TOTAL_FEE.RECORD_STATE == 1 && this.staticformFields.SPON_TOTAL_FEE.IS_MANDATORY) {
      if (formDate.TOTAL_FEE === null || formDate.TOTAL_FEE === "" || formDate.TOTAL_FEE === undefined) {
        $("#TOTAL_FEE").addClass("ng-touched ng-invalid validate-error");
        $("#TOTAL_FEE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields.SPON_TOTAL_FEE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        if (!isNaN(formDate.TOTAL_FEE)) {
          $("#TOTAL_FEE").addClass("ng-untouched ng-valid");
          $("#TOTAL_FEE").removeClass("ng-touched ng-invalid validate-error");
        }
        else {
          $("#TOTAL_FEE").addClass("ng-touched ng-invalid validate-error");
          $("#TOTAL_FEE").removeClass("ng-untouched ng-valid");
          message += `${this.staticformFields.SPON_TOTAL_FEE.LABEL_NAME} will allow only numeric values<br/>`;
          isValid = false;
        }
      }
    }

    if (this.staticformFields.SPON_REQUESTED_AMOUNT.RECORD_STATE == 1 && this.staticformFields.SPON_REQUESTED_AMOUNT.IS_MANDATORY) {

      if (formDate.REQUESTED_AMOUNT === null || formDate.REQUESTED_AMOUNT === "" || formDate.REQUESTED_AMOUNT === undefined) {
        $("#REQUESTED_AMOUNT").addClass("ng-touched ng-invalid validate-error");
        $("#REQUESTED_AMOUNT").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields.SPON_REQUESTED_AMOUNT.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        if (!isNaN(formDate.REQUESTED_AMOUNT)) {
          $("#REQUESTED_AMOUNT").addClass("ng-untouched ng-valid");
          $("#REQUESTED_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
        }
        else {
          $("#REQUESTED_AMOUNT").addClass("ng-touched ng-invalid validate-error");
          $("#REQUESTED_AMOUNT").removeClass("ng-untouched ng-valid");
          message += `${this.staticformFields.SPON_REQUESTED_AMOUNT.LABEL_NAME} field will allow only numeric values<br/>`;
          isValid = false;
        }
      }
    }

    let totalfee = parseInt(formDate["TOTAL_FEE"]);
    let requested = parseInt(formDate["REQUESTED_AMOUNT"]);

    if (requested > totalfee) {
      $("#REQUESTED_AMOUNT").addClass("ng-touched ng-invalid validate-error");
      $("#REQUESTED_AMOUNT").removeClass("ng-untouched ng-valid");
      message += "Requested amount cannot be more than total fee<br/>";
      isValid = false;
    } else {
      $("#REQUESTED_AMOUNT").addClass("ng-untouched ng-valid");
      $("#REQUESTED_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
    }

    if (this.IsAllocate == "Y" && this.userType == "I") {
      if (this.staticformFields?.SPON_ALLOCATION_AMOUNT.RECORD_STATE == 1 && this.staticformFields?.SPON_ALLOCATION_AMOUNT.IS_MANDATORY) {
        if (formDate.ALLOCATION_AMOUNT === null || formDate.ALLOCATION_AMOUNT === "" || formDate.ALLOCATION_AMOUNT === undefined) {
          $("#ALLOCATION_AMOUNT").addClass("ng-touched ng-invalid validate-error");
          $("#ALLOCATION_AMOUNT").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.SPON_ALLOCATION_AMOUNT?.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          //$("#TOTAL_FEE").addClass("ng-untouched ng-valid");
          //$("#TOTAL_FEE").removeClass("ng-touched ng-invalid validate-error");
          if (!isNaN(formDate.ALLOCATION_AMOUNT)) {
            $("#ALLOCATION_AMOUNT").addClass("ng-untouched ng-valid");
            $("#ALLOCATION_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
          }
          else {
            $("#ALLOCATION_AMOUNT").addClass("ng-touched ng-invalid validate-error");
            $("#ALLOCATION_AMOUNT").removeClass("ng-untouched ng-valid");
            message += "Allocation Amount field will allow only numeric values<br/>";
            isValid = false;
          }
        }
      }

      if (formDate["ALLOCATION_AMOUNT"] != null && parseInt(formDate["ALLOCATION_AMOUNT"]) > parseInt(formDate["REQUESTED_AMOUNT"])) {
        $("#ALLOCATION_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#ALLOCATION_DATE").removeClass("ng-untouched ng-valid");
        message += "The allocation amount cannot be greater than requested amount<br/>";
        isValid = false;
      } else {
        $("#ALLOCATION_DATE").addClass("ng-untouched ng-valid");
        $("#ALLOCATION_DATE").removeClass("ng-touched ng-invalid validate-error");
      }

      if (this.staticformFields?.SPON_ALLOCATION_DATE.RECORD_STATE == 1 && this.staticformFields?.SPON_ALLOCATION_DATE.IS_MANDATORY) {
        if (formDate.ALLOCATION_DATE === null || formDate.ALLOCATION_DATE === "" || formDate.ALLOCATION_DATE === undefined) {
          $("#ALLOCATION_DATE").addClass("ng-touched ng-invalid validate-error");
          $("#ALLOCATION_DATE").removeClass("ng-untouched ng-valid");
          message += `Please select ${this.staticformFields?.SPON_ALLOCATION_DATE?.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#ALLOCATION_DATE").addClass("ng-untouched ng-valid");
          $("#ALLOCATION_DATE").removeClass("ng-touched ng-invalid validate-error");
        }
      }
    }

    if (this.staticformFields?.SPON_ALLOCATION_NOTES.RECORD_STATE == 1 && this.staticformFields?.SPON_ALLOCATION_NOTES.IS_MANDATORY) {
      if (formDate.ALLOCATION_NOTES === null || formDate.ALLOCATION_NOTES === "" || formDate.ALLOCATION_NOTES === undefined) {
        $("#ALLOCATION_NOTES").addClass("ng-touched ng-invalid validate-error");
        $("#ALLOCATION_NOTES").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.SPON_ALLOCATION_NOTES?.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#ALLOCATION_NOTES").addClass("ng-untouched ng-valid");
        $("#ALLOCATION_NOTES").removeClass("ng-touched ng-invalid validate-error");
      }
    }


    if (this.staticformFields.SPON_REQUESTED_NOTES.RECORD_STATE == 1 && this.staticformFields.SPON_REQUESTED_NOTES.IS_MANDATORY) {
      if (formDate.NOTES === null || formDate.NOTES === "" || formDate.NOTES === undefined) {
        $("#REQUESTED_NOTES").addClass("ng-touched ng-invalid validate-error");
        $("#REQUESTED_NOTES").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields.SPON_REQUESTED_NOTES.LABEL_NAME}<br/>`;
        isValid = false;
      } else if (formDate.NOTES != null && formDate.NOTES != undefined && formDate.NOTES.trim() == "") {
        $("#REQUESTED_NOTES").addClass("ng-touched ng-invalid validate-error");
        $("#REQUESTED_NOTES").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields.SPON_REQUESTED_NOTES.LABEL_NAME}<br/>`;
        isValid = false;
      }
      else {
        $("#REQUESTED_NOTES").addClass("ng-untouched ng-valid");
        $("#REQUESTED_NOTES").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.IsAllocate == "Y" && this.userType == "E") {
      if (this.staticformFields.SPON_EXPENDITURE_AMOUNT.RECORD_STATE == 1 && this.staticformFields?.SPON_EXPENDITURE_AMOUNT.IS_MANDATORY) {
        if (formDate.EXPENDITURE_AMOUNT === null || formDate.EXPENDITURE_AMOUNT === "" || formDate.EXPENDITURE_AMOUNT === undefined || parseInt(formDate["EXPENDITURE_AMOUNT"]) == 0) {
          $("#EXPENDITURE_AMOUNT").addClass("ng-touched ng-invalid validate-error");
          $("#EXPENDITURE_AMOUNT").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.SPON_EXPENDITURE_AMOUNT.LABEL_NAME} <br/>`;
          isValid = false;
          //return false;
        } else {
          $("#EXPENDITURE_AMOUNT").addClass("ng-untouched ng-valid");
          $("#EXPENDITURE_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (formDate["EXPENDITURE_AMOUNT"] != null && parseInt(formDate["EXPENDITURE_AMOUNT"]) > parseInt(formDate["ALLOCATION_AMOUNT"])) {
        $("#EXPENDITURE_AMOUNT").addClass("ng-touched ng-invalid validate-error");
        $("#EXPENDITURE_AMOUNT").removeClass("ng-untouched ng-valid");
        message += "The expenditure amount cannot be greater than the allocated amount<br/>";
        isValid = false;
      } else {
        $("#EXPENDITURE_AMOUNT").addClass("ng-untouched ng-valid");
        $("#EXPENDITURE_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
      }
    }


    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      isValid = false;
      message = message + ExtenMsgs;
    }

    if (!isValid) {
      this.commonService.ValidationBanner(message)
    }
    return isValid;
  }
}
